import type { GatsbyConfig } from 'gatsby';
import i18nConfig from './i18n-config';

const config: GatsbyConfig = {
    siteMetadata: {
        title: 'axesCheck',
        siteUrl: process.env.GATSBY_SITE_URL ?? 'https://check.axes4.com',
    },
    // More easily incorporate content into your pages through automatic TypeScript type generation and better GraphQL IntelliSense.
    // If you use VSCode you can also use the GraphQL plugin
    // Learn more at: https://gatsby.dev/graphql-typegen
    graphqlTypegen: true,
    plugins: [
        {
            resolve: 'gatsby-plugin-sass',
            options: {
                sassRuleTest: /\.s([ac])ss$/,
                sassRuleModulesTest: /\.module\.s([ac])ss$/,
                postCssPlugins: [
                    'autoprefixer',
                    'postcss-flexbugs-fixes',
                    [ 'postcss-pxtorem', {
                        rootValue: 16,
                        unitPrecision: 5,
                        propList: [
                            'font',
                            'font-size',
                            'line-height',
                            'letter-spacing',
                            'width',
                            'min-width',
                            'max-width',
                            'height',
                            'min-height',
                            'max-height' ],
                        selectorBlackList: [],
                        replace: true,
                        mediaQuery: false,
                        minPixelValue: 0,
                    } ],
                    [ 'postcss-preset-env', {
                        preserve: true,
                        features: {
                            'focus-within-pseudo-class': false,
                        },
                    } ],
                ],
            },
        },
        'gatsby-plugin-image',
        'gatsby-plugin-sharp',
        'gatsby-transformer-sharp',
        {
            resolve: 'gatsby-source-filesystem',
            options: {
                path: `${ __dirname }/src/images/`,
            },
        },
        'gatsby-plugin-react-helmet',
        {
            resolve: 'gatsby-plugin-manifest',
            options: {
                name: 'axesCheck',
                start_url: '/',
                background_color: '#ffffff',
                theme_color: '#669C03',
                icon: 'src/images/favicon.svg',
                icons: [
                    {
                        src: 'src/images/favicon.ico',
                        sizes: '16x16',
                        type: 'image/vnd.microsoft.icon',
                    },
                    {
                        src: 'src/images/favicon.svg',
                        sizes: '16x16',
                        type: 'image/svg+xml',
                    },
                    ...[ '16x16', '32x32', '128x128', '192x192' ].map(s => ({
                        src: `src/images/icon-${ s }.png`,
                        sizes: s,
                        type: 'image/png',
                    })),
                    /*{
                     src: 'src/images/apple-touch-icon.png',
                     sizes: '180x180',
                     type: 'image/png',
                     },*/
                ],
            },
        },
        {
            resolve: 'gatsby-source-filesystem',
            options: {
                path: `${ __dirname }/locales`,
                name: 'locale',
            },
        },
        {
            resolve: 'gatsby-plugin-react-i18next',
            options: i18nConfig,
        },
        {
            resolve: 'gatsby-plugin-mdx',
            options: {
                gatsbyRemarkPlugins: [
                    {
                        resolve: 'gatsby-remark-autolink-headers',
                        options: {
                            icon: false,
                        },
                    },
                ],
            },
        },
        {
            resolve: 'gatsby-source-filesystem',
            options: {
                path: `${ __dirname }/content`,
                name: 'content',
            },
        },
        {
            resolve: 'gatsby-source-filesystem',
            options: {
                path: `${ __dirname }/src/pages`,
                name: 'pages',
            },
        },
        {
            resolve: 'gatsby-plugin-react-svg',
            options: {
                rule: {
                    include: /components.Icons/,
                },
            },
        },
    ],
};

export default config;
